var map = {
	"./Anyswap.png": 359,
	"./Anyswap.svg": 360,
	"./Artwork.svg": 361,
	"./Artwork_gmx.svg": 362,
	"./Banxa.png": 363,
	"./DROP_DOWN.svg": 181,
	"./Hop.png": 364,
	"./Hop.svg": 365,
	"./Hop_dark.png": 366,
	"./Hop_dark.svg": 367,
	"./Synapse.png": 368,
	"./Synapse.svg": 369,
	"./binance.png": 370,
	"./bscscan.png": 371,
	"./btn_big_arbitrum.png": 372,
	"./btn_big_avalanche.png": 373,
	"./btn_big_bsc.png": 374,
	"./btn_big_purchasegmx.png": 375,
	"./btn_big_purchasegmx.svg": 376,
	"./buy_gmx.svg": 377,
	"./buy_gmx_bond.svg": 378,
	"./buy_transfer_eth.svg": 379,
	"./coinbaseWallet.png": 251,
	"./coingecko.png": 380,
	"./cross.svg": 381,
	"./ddl/chevron-down.svg": 382,
	"./ddl/chevron-down_sm.svg": 383,
	"./ddl/ic_btc_40.png": 384,
	"./ddl/ic_btc_40.svg": 252,
	"./ddl/ic_dai_40.png": 385,
	"./ddl/ic_dai_40.svg": 253,
	"./ddl/ic_eth_40.png": 386,
	"./ddl/ic_eth_40.svg": 176,
	"./ddl/ic_frax_40.png": 387,
	"./ddl/ic_frax_40.svg": 254,
	"./ddl/ic_link_40.png": 388,
	"./ddl/ic_link_40.svg": 255,
	"./ddl/ic_uni_40.png": 389,
	"./ddl/ic_uni_40.svg": 256,
	"./ddl/ic_usdc_40.png": 390,
	"./ddl/ic_usdc_40.svg": 257,
	"./ddl/ic_usdt_40.png": 391,
	"./ddl/ic_usdt_40.svg": 258,
	"./ddl/ic_weth_40.png": 392,
	"./ddl/ic_weth_40.svg": 259,
	"./ddl/icon_arrow.svg": 393,
	"./ddl/icon_check.svg": 394,
	"./ddl/icon_close.svg": 395,
	"./ddl/icon_close_sm.svg": 396,
	"./ddl/icon_close_toast.svg": 397,
	"./ddl/icon_dollar.svg": 182,
	"./ddl/icon_dollar_active.svg": 183,
	"./ddl/icon_market.svg": 184,
	"./ddl/icon_market_active.svg": 185,
	"./ddl/icon_trigger.svg": 186,
	"./ddl/icon_trigger_active.svg": 187,
	"./ddl/icon_withdraw.svg": 188,
	"./ddl/icon_withdraw_active.svg": 189,
	"./ddl/lock.svg": 398,
	"./ddl/long.svg": 190,
	"./ddl/long_active.svg": 191,
	"./ddl/short.svg": 192,
	"./ddl/short_active.svg": 193,
	"./flag_en.svg": 399,
	"./flag_es.svg": 400,
	"./flag_fr.svg": 401,
	"./flag_ja.svg": 402,
	"./flag_ko.svg": 403,
	"./flag_ru.svg": 404,
	"./flag_zh.svg": 405,
	"./glp_icon.svg": 406,
	"./gmx-logo-final-white-small.png": 407,
	"./gmx-logo-final-white.png": 408,
	"./gmx-logo-final.png": 409,
	"./gmx-logo-glow.png": 410,
	"./gmx-logo-with-name.svg": 194,
	"./gmx_logo.svg": 411,
	"./graphite-01.png": 412,
	"./ic-communityproject.svg": 413,
	"./ic_arbitrum_16.svg": 414,
	"./ic_arbitrum_24.svg": 260,
	"./ic_arbitrum_96.svg": 415,
	"./ic_arbitrum_hover_16.svg": 416,
	"./ic_arrowleft16.svg": 417,
	"./ic_arrowright16.svg": 418,
	"./ic_avalanche_16.svg": 419,
	"./ic_avalanche_24.svg": 261,
	"./ic_avalanche_96.svg": 420,
	"./ic_avax_24.svg": 262,
	"./ic_avax_30.svg": 421,
	"./ic_avax_40.svg": 422,
	"./ic_banxa.svg": 423,
	"./ic_binance_logo.svg": 424,
	"./ic_bsc.svg": 425,
	"./ic_bsc_96.svg": 426,
	"./ic_btc.b_24.svg": 263,
	"./ic_btc.b_40.svg": 427,
	"./ic_btc_24.svg": 264,
	"./ic_btc_40.svg": 428,
	"./ic_busd_24.svg": 265,
	"./ic_buy_glp.svg": 429,
	"./ic_cash.png": 430,
	"./ic_cash.svg": 431,
	"./ic_checked.svg": 432,
	"./ic_coingecko_16.svg": 433,
	"./ic_coingecko_hover_16.svg": 434,
	"./ic_convert_down.svg": 435,
	"./ic_copy_16.svg": 436,
	"./ic_cost.svg": 437,
	"./ic_dai_24.svg": 266,
	"./ic_dai_40.svg": 438,
	"./ic_discord.svg": 195,
	"./ic_eth_24.svg": 267,
	"./ic_eth_40.svg": 439,
	"./ic_frax_24.svg": 268,
	"./ic_frax_40.svg": 440,
	"./ic_github.svg": 196,
	"./ic_glp_24.svg": 269,
	"./ic_glp_40.svg": 441,
	"./ic_glp_custom.svg": 442,
	"./ic_gmx.svg": 443,
	"./ic_gmx_24.svg": 270,
	"./ic_gmx_30.svg": 444,
	"./ic_gmx_40.svg": 445,
	"./ic_gmx_64.svg": 446,
	"./ic_gmx_arbitrum.svg": 447,
	"./ic_gmx_avax.svg": 448,
	"./ic_gmx_big.svg": 449,
	"./ic_gmx_custom.svg": 450,
	"./ic_gmx_footer.svg": 197,
	"./ic_hop.svg": 451,
	"./ic_info.svg": 452,
	"./ic_language24.svg": 453,
	"./ic_link_24.svg": 271,
	"./ic_link_40.svg": 454,
	"./ic_liquidity.svg": 455,
	"./ic_medium.svg": 198,
	"./ic_menu_dots.svg": 456,
	"./ic_metamask_16.svg": 457,
	"./ic_metamask_hover_16.svg": 458,
	"./ic_mim_24.svg": 272,
	"./ic_mim_40.svg": 459,
	"./ic_multiswap.svg": 460,
	"./ic_new_link_16.svg": 461,
	"./ic_olympus.svg": 462,
	"./ic_olympus_arbitrum.svg": 463,
	"./ic_selector_dropdowns.svg": 464,
	"./ic_settings_16.svg": 465,
	"./ic_settings_24.svg": 273,
	"./ic_sign in_16.svg": 466,
	"./ic_sign_out_16.svg": 467,
	"./ic_simpleswaps.svg": 468,
	"./ic_stats.svg": 469,
	"./ic_stats_big.svg": 470,
	"./ic_synapse.svg": 471,
	"./ic_telegram.svg": 199,
	"./ic_tether_24.svg": 274,
	"./ic_tokens.svg": 472,
	"./ic_totaluser.svg": 473,
	"./ic_trading.svg": 474,
	"./ic_transfer_avax.svg": 475,
	"./ic_twitter.svg": 200,
	"./ic_uni_24.svg": 275,
	"./ic_uni_40.svg": 476,
	"./ic_usdc.e_24.svg": 276,
	"./ic_usdc.e_40.svg": 477,
	"./ic_usdc_24.svg": 277,
	"./ic_usdc_40.svg": 478,
	"./ic_usdt_24.svg": 278,
	"./ic_usdt_40.svg": 479,
	"./ic_wallet_24.svg": 279,
	"./ic_wavax_24.svg": 280,
	"./ic_wavax_40.svg": 480,
	"./ic_weth_24.svg": 281,
	"./ic_weth_40.svg": 481,
	"./lg_arbitrum.svg": 482,
	"./logo_GMX.svg": 483,
	"./logo_GMX_small.svg": 484,
	"./long.svg": 485,
	"./metamask-text.svg": 486,
	"./metamask.png": 282,
	"./page-not-found.svg": 487,
	"./position-share-bg.png": 201,
	"./short.svg": 488,
	"./swap.svg": 202,
	"./trading.jpg": 489,
	"./wallet-connect-text.svg": 490,
	"./walletconnect-circle-blue.svg": 283,
	"./wave-01.png": 491,
	"./wave-02.png": 492
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 358;